var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIppanWh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002445;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(-260 65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-229.613,94.331h-.008l-25.774-.261a.75.75,0,0,1-.742-.75V89.264a.75.75,0,0,1,.335-.624l4.16-2.767,4.915-5.1a.75.75,0,0,1,.54-.23h12.924a.75.75,0,0,1,.612.317l3.65,5.159a.75.75,0,0,1,.138.433v7.128a.75.75,0,0,1-.222.533A.75.75,0,0,1-229.613,94.331Zm-25.024-1.753,24.274.246V86.691l-3.288-4.647h-12.217l-4.75,4.929a.751.751,0,0,1-.125.1l-3.894,2.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-251.159,86.452"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-251.104 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-251.104 90.164)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(-238.738 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(-238.738 90.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-239.707,87.2h-11.452V85.7h10.7V81.629h1.5v4.823A.75.75,0,0,1-239.707,87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-229.613,87.2h-7.263a.75.75,0,0,1-.75-.75V81.629h1.5V85.7h6.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-250.659,69.238a5.358,5.358,0,0,1,4.594,2.572l8.974-.006a4.528,4.528,0,0,1,3.568-1.729,4.56,4.56,0,0,1,2.88,1.027,4.568,4.568,0,0,1,1.571,2.567.75.75,0,0,1-.085.535l-.619,1.063a.75.75,0,0,1-1.023.272l-1.071-.619a.751.751,0,0,1-.1-.071l-.81-.468-.538.311v.622l.607.35.05.031,1.331.769a.75.75,0,0,1,.276,1.022l-.647,1.131a.75.75,0,0,1-.42.341,4.534,4.534,0,0,1-1.4.221,4.526,4.526,0,0,1-3.58-1.744l-8.962.009a5.359,5.359,0,0,1-4.594,2.572,5.4,5.4,0,0,1-3.409-1.216,5.409,5.409,0,0,1-1.859-3.039.75.75,0,0,1,.085-.535l.756-1.3a.75.75,0,0,1,1.023-.272l1.306.754a.75.75,0,0,1,.114.081l1.082.625.822-.474v-.949l-.823-.475q-.03-.017-.057-.037l-1.627-.939a.75.75,0,0,1-.276-1.022l.79-1.381a.75.75,0,0,1,.422-.342A5.4,5.4,0,0,1-250.659,69.238Zm4.153,4.072a.75.75,0,0,1-.671-.415,3.871,3.871,0,0,0-3.482-2.157,3.871,3.871,0,0,0-.924.113l-.267.467,1.039.6q.03.017.058.037l1.139.658a.75.75,0,0,1,.375.649v1.815a.75.75,0,0,1-.375.65l-1.572.907a.75.75,0,0,1-.75,0l-1.571-.907a.75.75,0,0,1-.114-.081l-.545-.315-.226.387a3.91,3.91,0,0,0,3.733,2.8,3.872,3.872,0,0,0,3.482-2.157.75.75,0,0,1,.67-.415l9.436-.009a1.31,1.31,0,0,0,.213-.02.75.75,0,0,1,.756.339,3.04,3.04,0,0,0,2.579,1.425,3.015,3.015,0,0,0,.668-.075l.123-.215-.734-.424-.049-.031-.932-.538a.75.75,0,0,1-.375-.65V74.258a.75.75,0,0,1,.375-.649l1.288-.744a.75.75,0,0,1,.75,0l1.288.744a.751.751,0,0,1,.1.071l.321.186.087-.15a3.069,3.069,0,0,0-2.913-2.141,3.04,3.04,0,0,0-2.572,1.414.75.75,0,0,1-.758.336,1.3,1.3,0,0,0-.218-.02l-9.436.006Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIppanWh);
export default __webpack_public_path__ + "static/media/icon_ippan_wh.01015a0be66964adf7585ac92163a49c.svg";
export { ForwardRef as ReactComponent };